import api from '../api/index';
import {DO_SEARCH, SEARCH_ADD_SUGGESTIONS} from './actions';

const WAIT_TIME = 400;
var Timeout = null;

export default store => next => action => {

	if(action.type !== DO_SEARCH) {
		next(action);
		return;
	}

	if(action.text.length <= 1){
		
		if(action.text.length === 0) {
			next({
		        type: SEARCH_ADD_SUGGESTIONS,
		        suggestions: {}
		    });
		}

		return next(action);
	}
	
	if(Timeout !== null) {
		clearTimeout(Timeout);
	}

	Timeout = setTimeout(() => {

		api('search').get({q:action.text, fields: 'index_,hash,name,pop_place,iso_code,x,y', iso_code: 'LVA,LTU,EST'}, (suggestions)=>{

			next({
		        type: SEARCH_ADD_SUGGESTIONS,
		        suggestions: suggestions
		    });
	    });

	}, WAIT_TIME);

	return next(action);
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/search/apiMiddleware.js